import React from 'react'
import styled, { keyframes } from 'styled-components'

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const LoaderContainer = styled.div<{ size: number }>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  display: inline-block;
`

const Spinner = styled.div<{ size: number }>`
  width: 100%;
  height: 100%;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-left: 2px solid #ffffff;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`

/**
 * Auto-generated CSS loading spinner
 * Takes in custom size, generates a spinning circle loader
 */
export const LoaderThin = ({ size = 16 }: { size?: number; [k: string]: any }): JSX.Element => {
  return (
    <LoaderContainer size={size}>
      <Spinner size={size} />
    </LoaderContainer>
  )
}
